import type { PublicRoute } from "../../../routes/registry";
import ProductDetailPage from "./ProductDetailPage";

/**
 * /products/:slug (Story #25441). The page titles itself "{name} | Greatway Patios Toowoomba" and uses
 * the product's first intro sentence as its meta description (BR-WEB-004, baseline § 3); these are the
 * route-level defaults it overrides.
 */
const route: PublicRoute = {
  path: "/products/:slug",
  element: <ProductDetailPage />,
  title: "Products | Greatway Patios Toowoomba",
  description: "Outdoor living products supplied and installed by Greatway Patios, Toowoomba.",
};

export default route;
